export const CREATE_PLAN_MUTATION_KEY = 'create-plan';